module.exports = __webpack_public_path__ + "img/table.ceb0c25b.png";